'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voter-group-edit.routes';

export class VoterGroupEditComponent {
  constructor(VoterGroupsService, Auth, $state, $stateParams, dialogs, $uibModal, PropertyService, ContactService) {
    'ngInject';

    this.VoterGroupsService = VoterGroupsService;
    this.PropertyService = PropertyService;
    this.ContactService = ContactService;

    this.$uibModal = $uibModal;

    this.groupId = $stateParams.id;

    this.dialogs = dialogs;

    this.jsonValue = "";
    this.$state = $state;

    this.contacts = ContactService.query();
    this.properties = PropertyService.query();

    this.types = [{
      name: "Properties",
      type: "properties"
    }, {
      name: "Contacts",
      type: "contacts"
    }];

    this.groupTemplate = {
      name: '',
      description: '',
      type: "properties",
      contacts: [],
      properties: [],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.group = angular.copy(this.groupTemplate);

    if (this.groupId) {
      this.VoterGroupsService.getWithData({id: this.groupId}, data => {
        this.group = data;
      }, err => {
        console.log('Could not load voter group from server');
      })
    }
  }

  contactLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {
            multiple: true,
            exclude: that.group.contacts.map(contact => String(contact._id))
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contacts) {
        contacts.forEach(contactId => {
          that.group.contacts.push(that.contacts.find(contact => contact._id == contactId));

        });
      },
      function () { /* cancel */ }
    );
  }

  propertyLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {
            multiple: true,
            exclude: that.group.properties.map(ppty => String(ppty._id))
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (properties) {
        properties.forEach(pptyId => that.group.properties.push(that.properties.find(ppty => ppty._id == pptyId)));
      },
      function () { /* cancel */ }
    );

  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  deleteContact(idx) {
    this.group.contacts.splice(idx, 1);
  }

  deleteProperty(idx) {
    this.group.properties.splice(idx, 1);
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.group = angular.copy(this.groupTemplate);
        this.submitted = false;

        var actionString = (this.groupId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The voter group has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("voter-group-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.group.contacts = this.group.contacts.map(contact => contact._id);
      this.group.properties = this.group.properties.map(property => property._id);

      if (this.groupId) {  // Save changes on the current settings
        this.VoterGroupsService.update({id: this.groupId}, this.group, onSuccess, onError);
      } else { // Create new settings
        this.VoterGroupsService.save(this.group, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.voterGroupEdit', [uiRouter])
  .config(routes)
  .component('voterGroupEdit', {
    template: require('./voter-group-edit.html'),
    controller: VoterGroupEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/voter-group-edit/voter-group-edit.component.js